/**
 * Sidebar del dashboard de usuario.
 *
 * Además de navegar entre vistas locales del panel, consulta Firestore para
 * mostrar nombre e imagen de perfil del usuario autenticado.
 */
import React, { useEffect, useState } from "react";
import "./NavbarD.scss";
import { useAuth } from "../context/AuthContext"; // Contexto de autenticación
import { useNavigate } from "react-router-dom"; // Para redireccionar
import { doc, getDoc } from "firebase/firestore"; // Para obtener doc de Firestore
import { db } from "../firebase"; // Tu configuración de Firebase

const NavbarD = ({ setView, activeView }) => {
  const { currentUser, logout } = useAuth();
  const [isOpen, setIsOpen] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth > 768 : true
  ); // Controla el menú lateral
  const [userData, setUserData] = useState(null); // Almacena los datos del usuario desde Firestore
  const navigate = useNavigate();

  // Efecto para obtener datos de Firestore con base en currentUser.uid
  useEffect(() => {
    const fetchUserData = async () => {
      if (currentUser?.uid) {
        try {
          const userRef = doc(db, "users", currentUser.uid);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            setUserData(userSnap.data()); // Guardamos los datos en el estado
          }
        } catch (error) {
          console.error("Error obteniendo datos de usuario:", error);
        }
      }
    };
    fetchUserData();
  }, [currentUser]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenuOnMobile = () => {
    if (window.innerWidth <= 768) {
      setIsOpen(false);
    }
  };

  const goToView = (view) => {
    setView(view);
    closeMenuOnMobile();
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login"); // Redirige al login tras cerrar sesión
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  // Funciones de navegación a distintas vistas del Dashboard
  const handleVerHomeDashboard = () => {
    goToView("home");
  };

  const handleVerHistorialClinico = () => {
    goToView("clinicalHistory");
  };

  const handleVerRutinas = () => {
    goToView("routines");
  };

  const handleVerDietas = () => {
    goToView("diets");
  };

  // Nuevo: Función para ir a la sección de ajustes de cuenta
  const handleAccountSettings = () => {
    goToView("accountSettings");
  };

  const handleVerAcompanamiento = () => goToView("acompanamiento"); // <- Nuevo

  const menuItems = [
    {
      view: "home",
      label: "Inicio",
      icon: "/assets/images/home_ico.png",
      alt: "Inicio Ico",
      onClick: handleVerHomeDashboard,
    },
    {
      view: "clinicalHistory",
      label: "Mis Medidas",
      icon: "/assets/images/historial_ico.png",
      alt: "Historial Ico",
      onClick: handleVerHistorialClinico,
    },
    {
      view: "routines",
      label: "Rutinas",
      icon: "/assets/images/calendario_ico.png",
      alt: "Rutinas Ico",
      onClick: handleVerRutinas,
    },
    {
      view: "diets",
      label: "Mis dietas",
      icon: "/assets/images/dietas_ico.png",
      alt: "Dietas Ico",
      onClick: handleVerDietas,
    },
    {
      view: "acompanamiento",
      label: "Acompañamiento",
      icon: "/assets/images/mensajes_ico.png",
      alt: "Acompañamiento Ico",
      onClick: handleVerAcompanamiento,
    },
    {
      view: "accountSettings",
      label: "Ajustes de cuenta",
      icon: "/assets/images/ajustes_ico.png",
      alt: "Ajustes de la cuenta ico",
      onClick: handleAccountSettings,
    },
  ];

  return (
    <nav className={`navbar-dashboard ${isOpen ? "open" : "closed"}`}>
      <div className="navbar-dashboard-top">
        <div className="logo-dashboard">
          <img src="/assets/images/logo-color.png" alt="Mentfull Logo" />
        </div>

        <button
          type="button"
          className="burger-dashboard"
          onClick={toggleMenu}
          aria-label={isOpen ? "Cerrar menú" : "Abrir menú"}
          aria-expanded={isOpen}
        >
          <img src="/assets/images/burger_ico.png" alt="menu dashboard" />
        </button>
      </div>

      <div className="navbar-dashboard-main">
        <div className="user-info">
          <div className="user-avatar">
            {/* Ajusta si tienes una foto en userData.profileImage */}
            <img
              src={
                userData?.profileImage
                  ? userData.profileImage
                  : "/assets/images/perfil_ico.png"
              }
              alt="User Avatar"
            />
          </div>
          {/* Aquí usamos el campo “name” de la colección “users” en Firestore */}
          <h2>{userData?.name ?? "Usuario"}</h2>
        </div>

        <ul className="menu-dashboard">
          {menuItems.map((item) => (
            <li
              key={item.view}
              className={activeView === item.view ? "active" : ""}
            >
              <button onClick={item.onClick} className="logout-button">
                <img src={item.icon} alt={item.alt} />
                <span className="menu-text">{item.label}</span>
              </button>
            </li>
          ))}
          <li>
            <button onClick={handleLogout} className="logout-button">
              <img
                src="/assets/images/cerrar_sesion_ico.png"
                alt="Cerrar sesión Ico"
              />
              <span className="menu-text">Cerrar sesión</span>
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default NavbarD;
